// extracted by mini-css-extract-plugin
export default {"container":"YfHJTcSO","heading":"mu1AujY_","danger":"ncUCKCdV","success":"PwdjTGZm"};